import React, { useContext, useMemo } from 'react';

import '../styles/Homepage.css';
import { bool } from 'prop-types';
import Seo from './Seo';
import AppContext from '../components/context/AppContext';
import HeroSlideshow from './HeroSlideshow';
import InfoGrid from './InfoGrid';
import RecentArticles from './RecentArticles';
import FilteredProductList from './FilteredProductList';

// Homepage component
// Rendered at the root path
const Homepage = ({ isMobile }) => {
    const { appContext } = useContext(AppContext);
    const appConfig = appContext.config.themeConfig;
    const slideShowItems = useMemo(() => [...appConfig.heroSection.images.map((section) => ({
        backgroundUrl: section.backgroundUrl,
    }))], [appConfig]);

    return (<>
        <Seo
            seoTitle={appConfig.seoTitle ?? appContext.config.storeName}
            seoType={'website'}
            seoDescription={appConfig.seoDescription}
            canonicalUrl={process.env.APP_URL}
        />
        <div
            className={'mx-1'}
        >
            <div
                className={'section p-md-0'}>
                <HeroSlideshow
                    isMobile={isMobile}
                    items={slideShowItems}
                />
            </div>
            <InfoGrid />
            <FilteredProductList
                isFeatured={true}
                title={'FEATURED PRODUCTS'}
                subTitle={'Top products, hand picked by Pool N Spa Store'}
                isMobile={isMobile}
            />
            <FilteredProductList
                isBestSelling={true}
                title={'MOST POPULAR PRODUCTS'}
                isMobile={isMobile}
            />
            <FilteredProductList
                isNew={true}
                title={'NEW PRODUCTS'}
                subTitle={'Find our latest designs + see what’s new at Pool N Spa Store'}
                isMobile={isMobile}
            />

            <RecentArticles />
        </div>
    </>);
};

Homepage.propTypes = {
    isMobile: bool,
};

export default Homepage;